module.exports = {
    SiteLink: 'SLNK',
    ExtLink: 'ELNK',
    Text: 'TXTMSG',
    Coupon: 'CUP',
    None: 'NONE'
  };